"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find");

var _campaign = require("@/api/campaign");

var _builtRecycle = require("@/api/builtRecycle");

var _admin = require("@/api/admin");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var _default = {
  name: "builtRecycle",
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    var validatorNum = function validatorNum(rule, value, callback) {
      console.log(value);
      var reg = /^\d+$/;

      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("只能输入数字"));
        } else {
          callback();
        }
      }
    };

    return {
      disabled: false,
      list: [],
      total: 0,
      listLoading: true,
      sysUsers: [],
      campaigns: [],
      createTime: '',
      nUserList: '',
      //待分配N访客服列表
      needAssignedUserId: '',
      //选中被需要被分配N访数据的客服
      assignedUsers: [],
      listQuery: {
        page: 1,
        limit: 10,
        startTime: "",
        endTime: "",
        campaignId: "",
        userId: "",
        order: "desc"
      },
      assignForm: {
        checkedUser: []
      },
      closedFormVisible: false,
      closedForm: {
        campaignId: '',
        ftotal: '',
        ntotal: ''
      },
      currBuilt: '',
      dialogFormVisible: false,
      dialogAssignedVisible: false,
      assignedUserId: '',
      taskCampaignId: '',
      assignedTaskTotal: '',
      assignedCampaignName: "",
      // 当前要分配得任务名称
      dialogStatus: "",
      textMap: {
        update: "任务编辑",
        create: "任务创建"
      },
      rules: {
        ftotal: [{
          required: true,
          message: "1访数据不能为空",
          trigger: "blur"
        }],
        ntotal: [{
          required: true,
          message: "n访数据不能为空",
          trigger: "blur"
        }],
        closedResult: [{
          required: true,
          message: "取消原因不能为空",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getList();
    this.getSysUser();
    this.getCampaigns();
  },
  methods: {
    handleRadioChange: function handleRadioChange(value) {
      var user;
      if (value) user = this.nUserList.find(function (item) {
        return item.userId === value;
      });
      this.assignForm.ntotal = user.nttl;
      this.assignForm.nUserId = user.userId;
      this.$forceUpdate();
      this.assignForm.checkedUser = [];
      this.assignedUsers = [];
    },
    getList: function getList() {
      var _this = this;

      if (this.createTime != null && this.createTime != '') {
        this.listQuery.startTime = this.createTime[0];
        this.listQuery.endTime = this.createTime[1];
      }

      this.listLoading = true;
      (0, _builtRecycle.builtList)(this.listQuery).then(function (response) {
        _this.list = response.data.data.list;
        _this.total = response.data.data.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.total = 0;
        _this.listLoading = false;
      });
    },
    handleClosed: function handleClosed(row) {
      this.currBuilt = row;
      this.closedFormVisible = true;
      this.closedForm.ftotal = 0;
      this.closedForm.ntotal = 0;
      this.closedForm.campaignId = row.campaignId;
      this.closedForm.closedTitle = "1访数据:" + row.ftotal + "  N访数据:" + row.ntotal;
    },
    confirmClosed: function confirmClosed() {
      var _this2 = this;

      if (this.closedForm.ftotal > this.currBuilt.ftotal || this.closedForm.ntotal > this.currBuilt.ntotal) {
        this.$notify.warning({
          title: '提示',
          message: '取消数量不能大于待拨数量'
        });
        return;
      }

      this.$refs["closedForm"].validate(function (valid) {
        if (valid) {
          _this2.$confirm("确定要取消指定数量的任务吗？", "提示", {
            confirmButtonText: "关闭",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            (0, _builtRecycle.closed)(_this2.closedForm).then(function (res) {
              _this2.$notify.success({
                title: '成功',
                message: '任务取消成功'
              });

              _this2.closedFormVisible = false;

              _this2.getList();
            });
          });
        }
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAssigned: function handleAssigned(row) {
      var _this3 = this;

      (0, _builtRecycle.getNTotal)({
        campaignId: row.campaignId
      }).then(function (res) {
        _this3.nUserList = res.data.data;
        _this3.assignedUserId = row.id;
        _this3.assignForm.ftotal = row.ftotal;
        _this3.assignForm.campaignId = row.campaignId;
        _this3.assignForm.checkedUser = [];
        _this3.dialogAssignedVisible = true;
        _this3.assignedUsers = [];
      });
    },
    handleChecked: function handleChecked(value) {
      var _this4 = this;

      console.log(value);
      var checked = [];
      this.sysUsers.forEach(function (user) {
        if (value.indexOf(user.id) >= 0) {
          var eu = _this4.assignedUsers.find(function (u) {
            return u.userId == user.id;
          });

          if (eu) checked.push(eu);else checked.push({
            userId: user.id,
            userName: user.userName,
            ntotal: 0,
            ftotal: 0
          });
        }
      });
      this.checkedUser = value;
      this.assignedUsers = checked;
    },
    updateAssigned: function updateAssigned() {
      var _this5 = this;

      // 任务分配保存 
      if (this.assignedUsers.length == 0) {
        this.$message.error("请选择需要至少一个坐席人员");
        return;
      }

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          console.log(_this5.assignedUsers);
          var ntotal = 0;

          _this5.assignedUsers.forEach(function (item) {
            ntotal = ntotal + item.ntotal;
          });

          if (ntotal == 0) {
            _this5.$message.error("请输入待分配数据");

            return false;
          }

          if (ntotal > _this5.assignForm.ntotal) {
            _this5.$message.error("N访分配数量不能大于任务总量");

            return false;
          }

          var params = {
            campaignId: _this5.assignForm.campaignId,
            nUserId: _this5.assignForm.nUserId,
            assignedUsers: _this5.assignedUsers
          };
          (0, _builtRecycle.assignTask)(params).then(function (response) {
            _this5.$message.success("N访任务回收分配成功");

            _this5.dialogAssignedVisible = false;

            _this5.getList();
          }).catch(function (err) {
            _this5.$message.error(err.data.errmsg);
          });
        }
      });
      console.log(this.assignedUsers, this.assignedNum);
    },
    handleRemoveUser: function handleRemoveUser(user, index) {
      // this.assignedUsers=this.assignedUsers.split(index,1); 
      this.assignedUsers.splice(index, 1);
      console.info(this.checkedUser);
      var uIndex = this.checkedUser.indexOf(user.id);
      if (uIndex >= 0) this.checkedUser.splice(uIndex, 1);
    },
    getSysUser: function getSysUser() {
      var _this6 = this;

      (0, _admin.queryByType)({
        type: 1
      }).then(function (res) {
        _this6.sysUsers = res.data.data;
      });
    },
    getCampaigns: function getCampaigns() {
      var _this7 = this;

      (0, _campaign.getAllCampaigns)().then(function (res) {
        _this7.campaigns = res.data.data;
      });
    }
  }
};
exports.default = _default;